"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = require("react");
var css_1 = require("../../css");
var util_1 = require("../../util");
var styles = css_1.sheet({
    ripple: {
        bdrad: '50%',
        h: '100px',
        w: '100px',
        pos: 'absolute',
        transform: 'scale(0)',
        op: 1,
        pointerEvents: 'none',
        '@keyframes decor-ripple': {
            '100%': {
                transform: 'scale(12)',
                op: 0,
            },
        },
    },
}, 'util_Ripple');
var Ripple = (function (_super) {
    tslib_1.__extends(Ripple, _super);
    function Ripple() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.el = null;
        _this.elRipple = null;
        _this.ref = function (originalRef) { return function (el) {
            _this.el = el;
            (originalRef || util_1.noop)(el);
        }; };
        _this.refRipple = function (el) {
            _this.elRipple = el;
        };
        _this.onMouseDown = function (originalMouseDown) { return function (event) {
            if (!_this.elRipple) {
                return;
            }
            var _a = _this.el.getBoundingClientRect(), left = _a.left, top = _a.top;
            var posX = left + window.scrollX;
            var posY = top + window.scrollY;
            var elX = event.pageX - posX;
            var elY = event.pageY - posY;
            var style = _this.elRipple.style;
            style.removeProperty('animation');
            style.top = elY - 50 + 'px';
            style.left = elX - 50 + 'px';
            setTimeout(function () {
                style.setProperty('animation', "decor-ripple " + _this.props.ms + "ms linear");
            }, 35);
            (originalMouseDown || util_1.noop)(event);
        }; };
        return _this;
    }
    Ripple.prototype.render = function () {
        var _a = this.props, children = _a.children, color = _a.color;
        var element = react_1.Children.only(children);
        var ripple = util_1.h('div', {
            className: styles.ripple,
            style: {
                background: color,
            },
            ref: this.refRipple,
        });
        var style = element.props.style || {};
        style = Object.assign({}, style, {
            overflow: 'hidden',
            position: 'relative',
        });
        var innerChildren = react_1.Children.toArray(element.props.children);
        innerChildren.push(ripple);
        return react_1.cloneElement.apply(void 0, [element, tslib_1.__assign({}, element.props, { style: style, ref: this.ref(element.props.ref), onMouseDown: this.onMouseDown(element.props.onMouseDown) })].concat(innerChildren));
    };
    Ripple.defaultProps = {
        color: 'rgba(0,0,0,.2)',
        ms: 400,
    };
    return Ripple;
}(react_1.Component));
exports.Ripple = Ripple;
//# sourceMappingURL=index.js.map